import {ActivityTypesDao} from '../../dao';
import {ErrorModel} from '../../models';
import { UserState } from '../../reducers/UserReducer';
import {SERVICE_CODE} from './_serviceCode';

const FUNCTION_CODE = 'GET_ALL_ACTIVITY_TYPES';

export async function getAllActivityTypes(userData: UserState["userProfileData"], params: string, page: number) {
    try {
        const result = await ActivityTypesDao.getAllActivityTypes(userData?.userToken as string, params, page);

        const metadata = {
            count: result.count,
            next: result.next,
            previous: result.previous
        };

        return {
            metadata,
            data: result.results
        };
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la récupération de la liste des types d\'activités',
            error: error
        });
    }
}
